import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
  'meeting-notes.field-1-name': {
    id: 'meeting-notes.field-1-name',
    defaultMessage: 'Meeting name',
    description:
      'The field name (and the default value/watermark) in field #1 for this database template. In this case: Meeting name'
  },
  'meeting-notes.field-2-name': {
    id: 'meeting-notes.field-2-name',
    defaultMessage: 'Discussion topics',
    description:
      'The field name (and the default value/watermark) in field #2 for this database template. In this case: Discussion topics'
  },
  'meeting-notes.field-2-select-option-1': {
    id: 'meeting-notes.field-2-select-option-1',
    defaultMessage: 'Resourcing',
    description:
      'The option value for option #1 in field #2 for this database template. In this case: Resourcing'
  },
  'meeting-notes.field-2-select-option-2': {
    id: 'meeting-notes.field-2-select-option-2',
    defaultMessage: 'Project plan',
    description:
      'The option value for option #2 in field #2 for this database template. In this case: Project plan'
  },
  'meeting-notes.field-2-select-option-3': {
    id: 'meeting-notes.field-2-select-option-3',
    defaultMessage: 'Scope',
    description:
      'The option value for option #3 in field #2 for this database template. In this case: Scope'
  },
  'meeting-notes.field-2-select-option-4': {
    id: 'meeting-notes.field-2-select-option-4',
    defaultMessage: 'Timelines',
    description:
      'The option value for option #4 in field #2 for this database template. In this case: Timelines'
  },
  'meeting-notes.field-2-select-option-5': {
    id: 'meeting-notes.field-2-select-option-5',
    defaultMessage: 'Backlog',
    description:
      'The option value for option #5 in field #2 for this database template. In this case: Backlog'
  },
  'meeting-notes.field-2-select-option-6': {
    id: 'meeting-notes.field-2-select-option-6',
    defaultMessage: 'Design',
    description:
      'The option value for option #6 in field #2 for this database template. In this case: Design'
  },
  'meeting-notes.field-2-select-option-7': {
    id: 'meeting-notes.field-2-select-option-7',
    defaultMessage: 'Content',
    description:
      'The option value for option #7 in field #2 for this database template. In this case: Content'
  },
  'meeting-notes.field-3-name': {
    id: 'meeting-notes.field-3-name',
    defaultMessage: 'Date',
    description:
      'The field name (and the default value/watermark) in field #3 for this database template. In this case: Date'
  },
  'meeting-notes.field-4-name': {
    id: 'meeting-notes.field-4-name',
    defaultMessage: 'Meeting notes',
    description:
      'The field name (and the default value/watermark) in field #4 for this database template. In this case: Meeting notes'
  },
  'meeting-notes.field-5-name': {
    id: 'meeting-notes.field-5-name',
    defaultMessage: 'Action items',
    description:
      'The field name (and the default value/watermark) in field #5 for this database template. In this case: Action items'
  },
  'meeting-notes.field-6-name': {
    id: 'meeting-notes.field-6-name',
    defaultMessage: 'Notetaker',
    description:
      'The field name (and the default value/watermark) in field #6 for this database template. In this case: Notetaker'
  },
  'meeting-notes.view-1-name': {
    id: 'meeting-notes.view-1-name',
    defaultMessage: 'All notes',
    description:
      'The view name for view #1 in this template. Displayed on the top left of the screen (below the database name). In this case: All notes'
  },
  'meeting-notes.entry-1-cell-1': {
    id: 'meeting-notes.entry-1-cell-1',
    defaultMessage: 'Project kickoff',
    description:
      'The text value of cell #1 in row (entry) #1 in this database template. In this case:  Project kickoff'
  },
  'meeting-notes.entry-1-cell-4': {
    id: 'meeting-notes.entry-1-cell-4',
    defaultMessage: 'Potential issues with cross-platform testing',
    description:
      'The text value of cell #4 in row (entry) #1 in this database template. In this case:  Potential issues with cross-platform testing'
  },
  'meeting-notes.entry-1-cell-5': {
    id: 'meeting-notes.entry-1-cell-5',
    defaultMessage: 'Update project plan',
    description:
      'The text value of cell #5 in row (entry) #1 in this database template. In this case:  Update project plan'
  },
  'meeting-notes.entry-2-cell-1': {
    id: 'meeting-notes.entry-2-cell-1',
    defaultMessage: 'Sprint planning',
    description:
      'The text value of cell #1 in row (entry) #2 in this database template. In this case:  Sprint planning'
  },
  'meeting-notes.entry-2-cell-4': {
    id: 'meeting-notes.entry-2-cell-4',
    defaultMessage: 'Allocate buffer time',
    description:
      'The text value of cell #4 in row (entry) #2 in this database template. In this case:  Allocate buffer time'
  },
  'meeting-notes.entry-2-cell-5': {
    id: 'meeting-notes.entry-2-cell-5',
    defaultMessage: 'Finalize milestones',
    description:
      'The text value of cell #5 in row (entry) #2 in this database template. In this case:  Finalize milestones'
  },
  'meeting-notes.entry-3-cell-1': {
    id: 'meeting-notes.entry-3-cell-1',
    defaultMessage: 'Design office hours',
    description:
      'The text value of cell #1 in row (entry) #3 in this database template. In this case:  Design office hours'
  },
  'meeting-notes.entry-3-cell-4': {
    id: 'meeting-notes.entry-3-cell-4',
    defaultMessage: 'Explore panel behavior',
    description:
      'The text value of cell #4 in row (entry) #3 in this database template. In this case:  Explore panel behavior'
  },
  'meeting-notes.entry-3-cell-5': {
    id: 'meeting-notes.entry-3-cell-5',
    defaultMessage: 'Design to provide updated mocks for project',
    description:
      'The text value of cell #5 in row (entry) #3 in this database template. In this case:  Design to provide updated mocks for project'
  }
});
